import AsyncView from 'shopify-asyncview';
import CurrencyConverter from 'shopify-currency-converter';
import rimg from 'rimg-shopify';
import ProductHighlights from '../snippets/ProductHighlights';

export default class StaticProductRecommendations {
  constructor(section) {
    this.section = section;
    this.productHighlights = new ProductHighlights(section.el, section.postMessage);

    const { productId } = section.data;
    const { limit } = section.data.settings;
    const recommendationsEl = section.el.querySelector('[data-product-recommendations]');

    this._loadRecommendations(recommendationsEl, productId, limit);
  }

  onSectionUnload() {
    this.productHighlights.unload();
  }

  _loadRecommendations(container, productId, limit) {
    const url = `/recommendations/products?section_id=static-product-recommendations&limit=${limit}&product_id=${productId}`;

    AsyncView.load(
      url,
    ).done(({ html }) => {
      container.innerHTML = html;

      rimg.watch(container);
      this.productHighlights.reload();

      const moneyItems = container.querySelectorAll('.money');

      for (let i = 0; i < moneyItems.length; i++) {
        CurrencyConverter.update(moneyItems[i]);
      }

      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }
    });
  }
}
